import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSkeletonLoader,{attrs:{"type":"text","loading":_vm.$apollo.queries.internalHistory.loading}},[_vm._t("default",function(){return [_c('span',_vm._b({},'span',_vm.$attrs,false),[_vm._v(_vm._s(_vm._f("humanizeDuration")(_vm.duration)))])]},{"durationType":_vm.durationType,"duration":_vm.duration,"item":_vm.item})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }